// Shared photo URLs cribbed from Dan's legacy site so every page on the new
// marketing site features his actual portraits and live shots — not stock
// imagery. Keep this list in one place so it's easy to swap a photo across
// every reference.

const CDN = "https://d1yei2z3i6k35z.cloudfront.net/12793360";

export const PHOTOS = {
  // Color portrait of Dan, close-mid, looking down at the keys
  danPortrait: `${CDN}/68e2239d06cc7_DSC06610.jpeg`,
  // Wide black-and-white shot, Dan at a grand
  danPiano: `${CDN}/68e76f67671e5__E6A1361_Original.JPG`,
  // Close-up of hands on the keys
  danHands: `${CDN}/68e76fc1b87a5_IMG_8796.jpg`,
  // Testimonial-card background, soft-warm performance shot
  warmRoom: `${CDN}/68e76f254b90b_83b9e0ab-a1f5-4ded-bf75-10e77ca41617.jpg`,
  // Quieter shot used on Soundbaths page (room + piano)
  quietRoom: `${CDN}/68e76ca244e16_PhotoAug25202275359PM.JPG`,
  // Black-and-white family/portrait — the existing hero photo
  berryFamilyBW: `${CDN}/68aac895b06c7_BerryFamilyJune2021-02430-bw.jpg`,
  // Hero image specifically chosen by Dan for the soundbath page
  soundbathHero: `${CDN}/68e414228c1cb_DSC06623.jpeg`,
  // Homepage hero — Dan at the piano, chosen June 2026
  homeHero: `${CDN}/6a974666549200.04988919_LZ7K1Z1w.jpeg`,
  // Testimonial photo for the Miriam Y. quote
  soundbathRoom: `${CDN}/68e895ca00c79_Screenshot2025-10-09at1.09.34AM.png`,
  // Alephonics interactive concert
  alephonicsConcert: `${CDN}/6a6d18dfd5fc71.97992441_IMG_9961.jpg`,
  // Jazz Meets Jewish interactive concert
  jazzMeetsJewish: `${CDN}/68e76f254b90b_83b9e0ab-a1f5-4ded-bf75-10e77ca41617.jpg`,
  // Gala / event music
  galaRoom: `${CDN}/68e77272579c3_IMG_9421.jpg`,
  // Behind the scenes — used on the patron welcome page
  danExcited: `${CDN}/68e809c58b05b_RebDoniel7.png`,
  // Lifecycle / private events — chosen by Dan, June 2026
  lifecycleEvent: `${CDN}/68e7728dea722_83b9e0ab-a1f5-4ded-bf75-10e77ca41617.jpg`,
};

export default PHOTOS;
